import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { ZonesService } from "src/app/services/zones.service";

@Component({
	selector: "app-confirm-division-change",
	templateUrl: "./confirm-division-change.component.html",
	styleUrls: ["./confirm-division-change.component.scss"],
})
export class ConfirmDivisionChangeComponent implements OnInit {
	constructor(public dialogRef: MatDialogRef<ConfirmDivisionChangeComponent>, private zonesService: ZonesService) {}

	ngOnInit(): void {}

	applyDivisionChange() {
		this.dialogRef.close();
		this.zonesService.confirmDivisionChange$.next();
	}

	cancelDivisionChange() {
		this.dialogRef.close();
	}
}
